<script>
import LecturerComponent from 'Vue/Web/Common/Lecturer/LecturerComponent.vue';
export default {
  components: {
    LecturerComponent,
  },
  el: '.content',
  data() {
    return {
      currentFilterSelect: '',
      currentSortSelect: '',
      currentKeywordSelect: '',
      currentClassMetaIdSelect: '',
      filterList: [
        {
          name: '全部專業人士',
          value: '',
        },
      ],
      sortList: [
        {
          name: '預設排序',
          value: '',
        },
      ],
    };
  },
  computed: {
    accessibleFilterList() {
      return this.filterList.filter(item => !item.authCheck || (item.authCheck && this.authCheck));
    },
  },
  mounted: function () {
    this.setUrlKeyWord();
  },
  methods: {
    updateFilter(value) {
      this.currentFilterSelect = value;
      this.onChangeFilter();
    },
    onChangeFilter() {
      const url = new URL(window.location.href);

      if (this.currentSortSelect) {
        url.searchParams.set('sort', this.currentSortSelect);
      } else {
        url.searchParams.delete('sort');
      }

      if (this.currentFilterSelect) {
        url.searchParams.set('filter', this.currentFilterSelect);
      } else {
        url.searchParams.delete('filter');
      }
      url.searchParams.delete('keyword');
      url.searchParams.delete('classMetaId');

      window.location.href = url.href;
    },
    onChangeSort() {
      const url = new URL(window.location.href);

      if (this.currentSortSelect) {
        url.searchParams.set('sort', this.currentSortSelect);
      } else {
        url.searchParams.delete('sort');
      }

      if (this.currentFilterSelect) {
        url.searchParams.set('filter', this.currentFilterSelect);
      } else {
        url.searchParams.delete('filter');
      }

      if (this.currentKeywordSelect) {
        url.searchParams.set('keyword', this.currentKeywordSelect);
      } else {
        url.searchParams.delete('keyword');
      }

      if (this.currentClassMetaIdSelect) {
        url.searchParams.set('classMetaId', this.currentClassMetaIdSelect);
      } else {
        url.searchParams.delete('classMetaId');
      }

      window.location.href = url.href;
    },
    setUrlKeyWord() {
      const url = new URL(window.location.href);
      this.currentSortSelect = url.searchParams.get('sort') ?? '';
      this.currentFilterSelect = url.searchParams.get('filter') ?? '';
      this.currentKeywordSelect = url.searchParams.get('keyword') ?? '';
      this.currentClassMetaIdSelect = url.searchParams.get('classMetaId') ?? '';
    },
  },
};
</script>
